































































import WeatherForecastHour from '@/components/WeatherForecastHour.vue';
import '@/icons/yws';
import { Weatherdata, WeatherInterval } from '@/types/weather';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {
        WeatherForecastHour
    }
})
export default class WeatherForecastSummary extends Vue {
    @Prop() private weatherForecast!: Weatherdata;
    @Prop() private weatherLocation!: Geolocation;
    @Prop() private isRefreshingData!: boolean;
    @Prop() private isDataLoaded!: boolean;

    /**
     * We jump over the first forecast interval, since that is now and we already show it
     */
    get sixHoursForecasts(): WeatherInterval[] {
        return this.weatherForecast.shortIntervals.slice(1, 7);
    }

    /**
     * We don´t need to check if weatherForecast and shortIntervals are set because this
     * computed method is called from v-if directive in template
     */
    get nowForecast(): WeatherInterval {
        return this.weatherForecast.shortIntervals[0];
    }
}
